import type { IMosaicTocExpanded, ITocActionDelete } from "./interface";

/**
 * Removes a section or entry from the ToC and tracks it for persistence.
 *
 * @param state - The current expanded ToC state.
 * @param action - The action identifying which item should be removed.
 * @returns The updated ToC state after the item is removed.
 */
export const toc_delete = (
  state: IMosaicTocExpanded,
  action: ITocActionDelete,
): IMosaicTocExpanded => {
  const newState: IMosaicTocExpanded = { ...state };
  const removed = newState.tocItems.find((item) => item.id === action.itemId);

  /* istanbul ignore else -- callers only request deletion for visible ToC items. */
  if (removed) {
    newState.tocItems = newState.tocItems.filter((item) => item.id !== action.itemId);
    if (removed.type === "Section") {
      newState.removedItems.push({ id: removed.id, changed: true });
    } else {
      newState.removedItems.push({
        id: removed.id,
        azsolId: removed.azsolId,
        version: removed.version,
        changed: true,
      });
    }
    newState.saving = true;
  }

  return newState;
};
